export default __webpack_public_path__ + "static/media/user-key-blue.85a4c723.svg";